export enum LoginError {
  NO_PHONE_NUMBER = 'NO_PHONE_NUMBER',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
  COOKIES_DISABLED = 'COOKIES_DISABLED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UN_MARKED_ERROR = 'UN_MARKED_ERROR',
  CODE_EXPIRED = 'CODE_EXPIRED',
  INVALID_CODE = 'INVALID_CODE',
  CUSTOMER_DOESNT_EXISTS = 'CUSTOMER_DOESNT_EXISTS',
  INVALID_EMAIL = 'INVALID_EMAIL',
  MEMBER_ALREADY_EXISTS = 'MEMBER_ALREADY_EXISTS',
  MEMBER_NOT_FOUND = 'MEMBER_NOT_FOUND',
}
